/**
 * Shared nav config. Read by the desktop `<NavMenu>` group in `__root.tsx`
 * and by the mobile `<MobileNav>` drawer. Keeping this in one place means
 * adding a report or master shows up in both layouts at once.
 */

import type { NavMenuItem } from "./NavMenu";

// The Documents dropdown retired 2026-08-05: every document type is now a
// first-class top-nav tab (Bilty · Truck challans · Lorry hire · Invoices),
// listed here only for the mobile drawer's flat section.
export const DOC_TABS: NavMenuItem[] = [
  { to: "/bilty", label: "Bilty" },
  { to: "/loading-slips", label: "Truck challans" },
  { to: "/lorry-hire-challans", label: "Lorry hire" },
  { to: "/invoices", label: "Invoices" },
  { to: "/payments/receipts", label: "Receipts" },
  { to: "/track", label: "Track truck" },
];

export const TOOLS_ITEMS: NavMenuItem[] = [
  {
    to: "/tools/cash-book",
    label: "Cash book",
    description: "Expenses, capital in, closing balance, net profit",
  },
  {
    to: "/tools/manual-tax-invoices",
    label: "Manual tax invoices",
    description: "Free-form invoice — bypasses bilty/party masters",
  },
];

export const MASTER_ITEMS: NavMenuItem[] = [
  { to: "/parties", label: "Parties", description: "Customers & vendors" },
  { to: "/trucks", label: "Trucks", description: "Fleet — owned + hired" },
  { to: "/drivers", label: "Drivers" },
  { to: "/materials", label: "Materials", description: "Goods catalogue with HSN" },
  {
    to: "/toll-plazas",
    label: "Toll plazas",
    description: "City & state for FASTag plaza names",
  },
];

export const ADMIN_REPORT_ITEMS: NavMenuItem[] = [
  {
    to: "/reports/bilty-360",
    label: "Bilty-360",
    description: "Customer billed → vendor cost → margin",
  },
  {
    to: "/reports/gst",
    label: "GST returns",
    description: "GSTR-1 + GSTR-3B with PDF & GSTN export",
  },
];

export const LEDGER_REPORT_ITEMS: NavMenuItem[] = [
  {
    to: "/reports/outstanding",
    label: "Outstanding",
    description: "Who owes us, whom we owe — with ageing",
  },
  {
    to: "/reports/ledger-party",
    label: "Party ledger",
    description: "Bilties + payments for a customer",
  },
  {
    to: "/reports/ledger-vendor",
    label: "Vendor ledger",
    description: "LHCs + vendor payments for an owner",
  },
  {
    to: "/reports/branch-pl",
    label: "Branch P&L",
    description: "Monthly revenue → vendor cost → margin",
  },
];

export function reportItemsFor(isAdmin: boolean): NavMenuItem[] {
  return isAdmin ? [...ADMIN_REPORT_ITEMS, ...LEDGER_REPORT_ITEMS] : LEDGER_REPORT_ITEMS;
}
